import { FormControl } from "@angular/forms";

/**
 * Strongly-typed form controls for customer filters
 * Matches old QMC dashboard-customers.component.html filters:
 * - Start Date / End Date (customerCreatedRange)
 * - Search
 * - Filter by Deleted (includeDeleted)
 */
export interface ICustomerFilterControls {
  siteId: FormControl<number>;
  search: FormControl<string | null>;
  customerCreatedRange: FormControl<Date[] | null>;
  includeDeleted: FormControl<boolean>;
  pageSize: FormControl<number>;
  page: FormControl<number>;
  sortBy: FormControl<string | null>;
  sortDirection: FormControl<"asc" | "desc">;
}

/**
 * API filter request structure
 * Matches old QMC QPilotFilter for customer summaries
 * Old QMC filters (dashboard-customers.component.html):
 * - Start Date / End Date
 * - Search
 * - Filter by Deleted
 */
export interface CustomerFilter {
  siteId: number;
  search?: string;
  customerCreatedFromDate?: Date;
  customerCreatedToDate?: Date;
  pageSize: number;
  page: number;
  orderBy?: string;
  order?: "asc" | "desc";

  // Status filter (e.g., "Active", "Paused", "Active,Paused")
  // Old QMC defaults to "Active" for customers
  status?: string;

  // Site UTC offset for timezone-aware queries
  // Old QMC: filter.offset = site.UtcOffset
  offset?: number;

  // Include inactive records (active=false means include inactive)
  // Old QMC: &active=${!filter.includeInactive}
  // Default: includeInactive=false → active=true
  includeInactive?: boolean;

  // Include invalid records (valid=false means include invalid)
  // Old QMC: &valid=${!filter.includeInvalid}
  // Default: includeInvalid=false → valid=true
  includeInvalid?: boolean;

  // Show deleted customers only
  // Old QMC: &isDeleted=${filter.isDeleted}
  isDeleted?: boolean;
}

/**
 * Default filter values
 * Matches old QMC defaults for customer list
 */
export const DEFAULT_CUSTOMER_FILTER_VALUES = {
  pageSize: 20,
  page: 1,
  sortDirection: "asc" as const,
  sortBy: "Id",
  // Old QMC defaults: status=Active, active=true, valid=true
  status: "Active",
  includeInactive: false, // → active=true
  includeInvalid: false, // → valid=true
  isDeleted: false,
} as const;

/**
 * Page size options
 * Matches scheduled-orders pattern: [5, 10, 20, 25, 50, 100]
 * IMPORTANT: Default pageSize (20) MUST be included in this array
 */
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 25, 50, 100] as const;
